const axios = require('axios')

const SERVICE = 'user-service'

const login = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/login')

const logout = async (api, body) => {
  await api
    .setMethod()
    .get()
    .setService(SERVICE)
    .setAuthorizationToken(body.token)
    .process('/logout')
}

const logoutUser = async api => {
  await api.setMethod().get().setService(SERVICE).process('/logout')
}

const updateEmail = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/profile')

  const Emailcode = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/email-otp')

  

const register = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/register')
const loginPhone = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/phone-number')

const me = async api => api.setMethod().get().setService(SERVICE).process('/me')

const loginOtp = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/otp-login')

const loginGoogle = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/google-login')

const loginApple = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/apple-login')

const forgetPassword = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/forgot-password')

const changePassword = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/change-password')

const postUser = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/admin/user')

const importUser = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/import')

const bulkUpdateUser = async (api, body) => api
  .setMethod()
  .put()
  .setService(SERVICE)
  .setBody(body)
  .process('/import')

const getUsersListApi = async (api, params = {}) => api.setMethod().get().setService(SERVICE).process('/admin/user', params)

const getSingleUserApi = async (api, id) => api.setMethod().get().setService(SERVICE).process(`/admin/user/${id}`)

const updateUserApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/user/${id}`)

const deleteUserApi = async (api, id) => api.setMethod().delete().setService(SERVICE).process(`/admin/user/${id}`)

const getAdminDoctorsListApi = async (api, params = {}) => api.setMethod().get().setService(SERVICE).process('/admin/doctor', params)

const getAdminDoctorApi = async (api, id) => api.setMethod().get().setService(SERVICE).process(`/admin/doctor/${id}`)

const createAdminDoctorApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/doctor')

const updateAdminDoctorApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/doctor/${id}`)

const updateAdminDoctorStatusApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/doctor/${id}/status`)

const postAdminDoctorDigitalSigApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/doctor/${id}/digital`)

const revokeAdminDoctorDigitalSigApi = async (api, id) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process(`/admin/doctor/${id}/revoke`)

const postAdminDoctorAuthPinApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/doctor/${id}/pin`)

const postAdminDoctorSpecsApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/doctor/${id}/specification`)

const deleteAdminDoctorApi = async (api, id) => api.setMethod().delete().setService(SERVICE).process(`/admin/doctor/${id}`)

const getAdminPanelUsersListApi = async (api, params = {}) => api.setMethod().get().setService(SERVICE).process('/admin/admin', params)

const getSingleAdminPanelUserApi = async (api, id) => api.setMethod().get().setService(SERVICE).process(`/admin/admin/${id}`)

const createAdminPanelUserApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/admin')

const updateAdminPanelUserApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/admin/${id}`)

const checkEmail = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/email')

const corporateVerify = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/corporate-verify')

const corporateActivate = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/corporate-activate')

const validatePhoneNumber = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/validate-phone-number')

const getProfile = async (api, params = {}) => api.setMethod().get().setService(SERVICE).process('/profile', params)

const putProfile = async (api, body) => api.setMethod().put().setBody(body).setService(SERVICE)
  .process('/profile')

const postDocDigitalInfoApi = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/doctor/digital')

const changePasswordMarketplace = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/profile/change-password')

const getDoctorDetailsApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/doctor/${id}`)

const getDoctorIdApi = async id => {
  const getDocIdInstance = axios.create({
    timeout: 30000,
  })
  const headersList = {
    Accept: '*/*',
    'Content-Type': 'application/json',
  }

  const reqOptions = {
    url: `https://www.doconcall.com.my/find-doctor/api-v1/teleconsult-v2/doctor-detail/${id}?key=182cm983yrcm398rcoiejr`,
    method: 'GET',
    headers: headersList,
  }
  const response = await getDocIdInstance.request(reqOptions)
  return response
}

const postDoctorPinApi = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/doctor/pin')

module.exports = {
  login,
  register,
  me,
  loginOtp,
  loginGoogle,
  postUser,
  importUser,
  bulkUpdateUser,
  getUsersListApi,
  getSingleUserApi,
  updateUserApi,
  deleteUserApi,

  getAdminDoctorsListApi,
  getAdminDoctorApi,
  createAdminDoctorApi,
  updateAdminDoctorApi,
  updateAdminDoctorStatusApi,
  postAdminDoctorDigitalSigApi,
  revokeAdminDoctorDigitalSigApi,
  postAdminDoctorAuthPinApi,
  postAdminDoctorSpecsApi,
  deleteAdminDoctorApi,

  getAdminPanelUsersListApi,
  getSingleAdminPanelUserApi,
  createAdminPanelUserApi,
  updateAdminPanelUserApi,

  forgetPassword,
  changePassword,
  logout,
  loginPhone,
  checkEmail,
  corporateVerify,
  corporateActivate,
  validatePhoneNumber,
  getProfile,
  putProfile,
  loginApple,
  postDocDigitalInfoApi,
  updateEmail,
  logoutUser,
  changePasswordMarketplace,
  Emailcode,
  getDoctorDetailsApi,
  getDoctorIdApi,

  postDoctorPinApi,
}
